import { Box } from '@mui/material';
import React from 'react';
import { useAlertConfig, useUserState } from '../../../../../hooks';
import { AlertAttachments } from './AlertAttachments';
import { AlertDeliveryOrder } from './AlertDeliveryOrder';
import { AlertLongMessage } from './AlertLongMessage';
import { AlertPhinDetails } from './AlertPhinDetails';
import { AlertResponseOptions } from './AlertResponseOptions';
import { AlertShortMessage } from './AlertShortMessage';
import { AlertVoiceMessage } from './AlertVoiceMessage';
import { CollapsableSection } from './CollapsableSection';
export const AlertDetails = ({ data, isTabSelected }) => {
    const { renderAdditionalWizardStepDetails } = useAlertConfig();
    const userState = useUserState();
    const showJson = userState && (userState === null || userState === void 0 ? void 0 : userState.environment) === 'local';
    const additionalWizardStepDetails = renderAdditionalWizardStepDetails === null || renderAdditionalWizardStepDetails === void 0 ? void 0 : renderAdditionalWizardStepDetails(data, getCustomAlertData(data));
    const boxRef = React.useRef();
    React.useEffect(() => {
        if (boxRef.current && isTabSelected) {
            boxRef.current.focus();
        }
    }, [isTabSelected]);
    return (React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 2 }, ref: boxRef, tabIndex: -1 },
        React.createElement(AlertShortMessage, { data: data }),
        React.createElement(AlertLongMessage, { data: data }),
        React.createElement(AlertVoiceMessage, { data: data }),
        React.createElement(AlertAttachments, { data: data }),
        React.createElement(AlertPhinDetails, { data: data }),
        React.createElement(AlertResponseOptions, { data: data }),
        React.createElement(AlertDeliveryOrder, { data: data }),
        additionalWizardStepDetails && (React.createElement(CollapsableSection, { title: additionalWizardStepDetails.title, header: additionalWizardStepDetails.header }, additionalWizardStepDetails.children)),
        showJson && (React.createElement(CollapsableSection, { title: 'JSON', header: null },
            React.createElement(Box, { p: 2 },
                React.createElement("pre", { style: { margin: 0, whiteSpace: 'pre-wrap' } }, JSON.stringify(data, undefined, '  ')))))));
};
function getCustomAlertData(data) {
    var _a;
    return ((_a = data.additionalData) === null || _a === void 0 ? void 0 : _a.customAlertData) != null ? JSON.parse(data.additionalData.customAlertData) : undefined;
}
